// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"1c9f3bc4","563":"2e141a0b","787":"9d90be58"}[chunkId] + ".chunk.js";
};